import PropTypes from 'prop-types'
import { Children, PureComponent } from 'react'
import SwipeableViews from 'react-swipeable-views'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import Icon from '../Icon'
import SimpleButton from '../SimpleButton'

import styles from './index.css'

class HorizontalScroll extends PureComponent {
  state = {
    activeIndex: 0,
  }

  getChildren = () => Children.toArray(this.props.children)

  getCurrentSlidePosition = () => this.state.activeIndex + 1

  goToNextSlide = () => this.setState((prevState) => ({ activeIndex: prevState.activeIndex + 1 }))

  goToPrevSlide = () => this.setState((prevState) => ({ activeIndex: prevState.activeIndex - 1 }))

  goToSlide = (activeIndex) => this.setState({ activeIndex })

  shouldRenderLeftArrow = () => this.state.activeIndex > 0

  shouldRenderRightArrow = () => this.state.activeIndex < this.getChildren().length - 1

  renderBullets = () => (
    <ul className={styles.bullets}>
      {this.getChildren().map((_, index) => {
        const bulletIsActive = index === this.state.activeIndex
        return (
          <li key={index} className={styles.bullet}>
            <SimpleButton
              ariaLabel={`Ir a la página ${index + 1} de ${this.getChildren().length}`}
              onClick={() => this.goToSlide(index)}
              primary={bulletIsActive}
            />
          </li>
        )
      })}
    </ul>
  )

  renderLeftArrow = () => (
    <SimpleButton
      ariaLabel={`Ir a la página anterior: ${this.getCurrentSlidePosition() - 1} de ${this.getChildren().length}`}
      className={cn(styles.arrow, styles.arrowLeft)}
      onClick={this.goToPrevSlide}
      primary
    >
      <Icon className={styles.arrowIcon} name="arrow" />
    </SimpleButton>
  )

  renderRightArrow = () => (
    <SimpleButton
      ariaLabel={`Ir a la página siguiente: ${this.getCurrentSlidePosition() + 1} de ${this.getChildren().length}`}
      className={cn(styles.arrow, styles.arrowRight)}
      onClick={this.goToNextSlide}
      primary
    >
      <Icon className={styles.arrowIcon} name="arrow" />
    </SimpleButton>
  )

  render() {
    const { children, className } = this.props
    const shouldRenderBullets = this.getChildren().length > 1

    return (
      <div className={cn(styles.horizontalScroll, className)}>
        <div className={styles.slide}>
          <div className={styles.arrowContainer}>{this.shouldRenderLeftArrow() && this.renderLeftArrow()}</div>
          <SwipeableViews
            className={styles.view}
            enableMouseEvents
            index={this.state.activeIndex}
            onChangeIndex={this.goToSlide}
            tabIndex={-1}
          >
            {children}
          </SwipeableViews>
          <div className={styles.arrowContainer}>{this.shouldRenderRightArrow() && this.renderRightArrow()}</div>
        </div>

        {shouldRenderBullets && this.renderBullets()}
      </div>
    )
  }
}

HorizontalScroll.propTypes = {
  children: ChildrenSchema.isRequired,

  className: PropTypes.string,
}

export default HorizontalScroll
